@if (message) {
  <div [class]="alertClass">
    <svg class="data-alert-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" [attr.d]="iconPath" />
    </svg>
    <span class="data-alert-message">{{ message }}</span>
  </div>
}
